module.exports = __webpack_public_path__ + "static/logo-pphe-d9b4568525d854cbf876285d70aa274b.png";